import * as React from "react";
import { BaseBlock, broadcastBlockLoad } from "sb-resp-block-lib";
import { BaseDict } from "./dict";
import { config } from "./config";
import { RacingCurrentEvents } from "./RacingCurrentEvents";
import { RacingCurrentEventsData } from "./data";
let _;
let _localMocks;
let PageMethodsMock;
let RacingPageMethodsMock;
if (process.env.NODE_ENV === "development") {
    _ = require("sb-legacy-integration/lib-esm/mocks");
    _localMocks = require("../../mocks");
    PageMethodsMock = _.PageMethodsMock;
    RacingPageMethodsMock = _localMocks.RacingPageMethodsMock;
}
export class RacingCurrentEventsRoot extends BaseBlock {
    // constructor sets defaults
    constructor(domId, options = {
        dict: BaseDict,
        cms: {},
        navHandler: {},
        dataProvider: {},
    }, racingGameBlockNavigation) {
        super(domId, options);
        if (process.env.NODE_ENV === "development") {
            // setup data mocks for debug build
            this.dataProvider = new RacingCurrentEventsData({
                pageMethods: new PageMethodsMock(),
                racingPageMethods: new RacingPageMethodsMock()
            }, () => { });
            // setup dictionary for debug build
            this.options.dict = BaseDict;
            //export data store to window for debug purposes
            window["RacingCurrentEventsDATA"] = this.dataProvider;
        }
        if (process.env.NODE_ENV === "production" && typeof options.dataProvider !== "undefined") {
            // use pagemethods passed during the construction from the
            // mobile application
            this.dataProvider = new RacingCurrentEventsData(options.dataProvider, racingGameBlockNavigation);
        }
        // if no provided dictionary is not full fill in the missing keys with the base one
        this.options.dict = Object.assign(Object.assign({}, BaseDict), (options.dict || {}));
        // merge default and CMS options
        this.options.cms = Object.assign(Object.assign({}, config), (options.cms || {}));
    }
    activate() {
        return super.activate(React.createElement(RacingCurrentEvents, { dataProvider: this.dataProvider, dict: this.options.dict }));
    }
}
window["RacingCurrentEvents"] = RacingCurrentEventsRoot;
broadcastBlockLoad("RacingCurrentEvents");
//# sourceMappingURL=index.js.map